<template>
    <div id="OTP">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <div class="content">
        <h2>輸入驗證碼</h2>
        <img src="../assets/icon-otp.svg" alt="" class="icon">
        <p>已發送至您手機 <span class="clarity-mask">{{ otpInfo.otpMobile }}</span> 以及信箱 <span class="clarity-mask">{{ otpInfo.otpEmail }}</span></p>

        <div class="code">
            <span class="frontCode">{{ otpFrontCode }}</span><span>-</span>
            <input type="text" required="required" placeholder="請輸入6位數驗證碼" v-model="otpBackCode" id="otpCode"
                @keyup="reValBackCode" @keypress="reValBackCode"  @input="reValBackCode" class="inputStyle tlf_n_all clarity-unmask" :class="{ 'alertNoContent': check1 }"  inputmode="numeric" autocomplete="one-time-code"/>
        </div>
        <div class="countDown clarity-unmask">
            <vue-countdown v-if="counting" :time="otpExpireSec * 1000" :transform="transformSlotProps" v-slot="{minutes, seconds}" @end="timeEnd">剩餘時間 {{minutes}} : {{seconds}}</vue-countdown>
            <p class="link" @click="resetOTP" v-else>重新發送驗證碼</p>
        </div>
        </div>
        <div class="btnArea">
            <button class="btn send otp_go_accu" @click="sendOTP">確定</button>
        </div>
        <div class="otpBottom">
            <div class="container">
                <p class="link" @click="otpAlert">收不到驗證碼嗎?</p>
                <!--                <p>注意：若您的手機或 Email 已變更，請聯繫客服，修改您的個人資料。</p>
                                <p>網路服務專線：0800-366-168 (服務時間：週一至週五上午8:30-下午5:30，國定假日除外)</p>-->
            </div>
        </div>
    </div>
</template>
<script setup>

        import Loading from "@/components/loading.vue";
        import _ from 'lodash';
        import {getApi, postApi} from "@/utils/callApi";
        import {popUp} from "@/utils/popUp";
        import {inject, onMounted, ref} from "vue";
        import gtm from "@/utils/gtmDataLayer";
        import VueCountdown from '@chenfengyuan/vue-countdown';
        import Swal from "sweetalert2";
        import userStatus from "@/utils/userStatus";
        import apiConfig from "@/utils/apiConfig";
        import {useRouter} from "vue-router";
        import moment from "moment";

        const emits = defineEmits(["checkLogin"]);
        const router = useRouter();//轉跳router
        const cookies = inject('$cookies');

        let otpObj = null;
        let startCheck = false;
        let otpType = null;

        let regData = null;
        let logData = null;
        let applicationNo = null;

        const otpFrontCode = ref("");
        const otpBackCode = ref("");
        const otpExpireSec = ref(0);
        const check1 = ref(false);
        const isLoading = ref(false);
        const otpInfo = ref({
            otpId: "",
            otpMobile: "",
            otpEmail: "",
            otpFrontCode: "",
        });
        const counting = ref(true);

        let termsMember =  [];//CMS會員條款
        let termsMemberTravel = []; //CMS會員條款for旅平險
        let termsMemberList = {}; //整理後的條款資料
        let isOverflow = false;//是否系統超載 true:超載 false:正常
        let sourceRemark = '旅平險(國內)'
        let bannerLogin = false;

        //初始載入
        const getData = ()=>{
            otpType = sessionStorage.getItem("otpType");
            logData = JSON.parse(sessionStorage.getItem("logData"));
            regData = JSON.parse(sessionStorage.getItem("regData"));

            applicationNo = sessionStorage.getItem("applicationNo");
            console.log(applicationNo)
            const jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));

            if(otpType === 'login' || otpType === 'register'){
                if(jwtInfo !== null){
                    router.push('/count1')
                }
                else{
                    switch (otpType) {
                        case 'login':
                            otpLogin();
                            break;
                        case 'register':
                            otpRegister();
                            break;
                    }
                }
            }
            if(otpType === 'confirm'){
                if(applicationNo){
                    sendPayOtp();
                }else{
                    router.push('/count1')
                }
            }
        }

        const resetCount = ()=>{
            otpObj = JSON.parse(sessionStorage.getItem('otp'));
            if(otpObj){
                otpInfo.value = otpObj;
                otpFrontCode.value = otpObj.otpFrontCode;
                //計算倒數載入
                const startDate = new Date();
                const endDate = new Date(otpInfo.value.otpExpireTime);
                const countSec = (endDate.getTime() - startDate.getTime()) / 1000;
                otpExpireSec.value = parseInt(countSec);
                if(otpObj.type === "confirm"){
                    if(applicationNo ==  null || applicationNo === ""){
                        Swal.fire({
                            title: "流程錯誤",
                            confirmButtonText: "確定",
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>請重新進行投保</p>',
                        }).then(()=>{
                            router.push("/");
                        })
                    }
                }
            }
        }

        //手機自動帶入可擷取後六碼
        const reValBackCode = ()=> {
            otpBackCode.value = otpBackCode.value.replace(/[^0-9]/g, "").substr(-6);
        }

        //時間到期
        const timeEnd = ()=>{
            counting.value = false //倒數結束

            /*var errorUrl = require('../assets/error.svg');
            Swal.fire({
                title: "驗證碼失效",
                html: "<img src='" + errorUrl + "' /><p>您的驗證碼已到期！將回到上一頁</p>",
                confirmButtonText: "確定",
                showCloseButton: true,
                customClass: {
                    closeButton: "otp_fail_close_accu",
                    confirmButton: "otp_fail_go_accu"
                }
            }).then(() => {
                router.go(-1);
            });*/
        }

        //時間格式(2位數以下補0)
        const transformSlotProps = (time)=>{
            const formattedProps = {};
            Object.entries(time).forEach(([key, value]) => {
                formattedProps[key] = value < 10 ? `0${value}` : String(value);
            });
            return formattedProps;
        }

        //檢查輸入
        const checkForm = ()=>{
            if(startCheck){
                if(otpBackCode.value.length === 0){
                    check1.value = true;
                }else{
                    check1.value = false;
                }
            }
        }

        //送出驗證碼
        const sendOTP = _.debounce(()=>{
            startCheck = true;
            let checkFlag = 0;
            let errorMsg = [];
            checkForm();
            if (check1.value){
                checkFlag++;
                errorMsg.push('請輸入驗證碼');
            }

            if(checkFlag === 0){
                isLoading.value = true;

                switch (otpType) {
                    case 'login':
                        sendOTPLogin();
                        break;
                    case 'register':
                        sendOTPRegister();
                        break;
                    case 'confirm':
                        payOtpCheck();
                        break;
                }

            }else{
                Swal.fire({
                    title: "填寫資料錯誤",
                    showConfirmButton: false,
                    showCloseButton: true,
                    confirmButtonText: "確定",
                    html: '<img src="error.svg"><p>'+ errorMsg + '</p>',
                });
            }
        }, 10);

        //OTP登入
        const sendOTPLogin = ()=>{

            let otpData = {
                otpId: otpInfo.value.otpId,
                otpFrontCode: otpInfo.value.otpFrontCode,
                otpBackCode: otpBackCode.value,
                birthday: logData.birthday.year +'-'+ logData.birthday.month +'-'+ logData.birthday.date,
                sourceRemark: sourceRemark
            };

            userStatus.checkOtpLogin(
                otpData,
                (jwtInfo)=>{
                    isLoading.value = false;
                    localStorage.setItem('jwtInfo', JSON.stringify(jwtInfo));
                    sessionStorage.removeItem('otp');
                    sessionStorage.removeItem('otpType');
                    sessionStorage.removeItem('logData');
                    var fromPage = sessionStorage.getItem("fromPage");
                    //emit('checkLogin');
                    sendFpc();
                    gtm.memberEvent('login');
                    if(fromPage){
                        sessionStorage.removeItem("fromPage");
                        router.push(fromPage);
                    }else{
                        jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));//以防停留頁面沒有重新更新到token
                        if(jwtInfo != null){
                            emits("checkLogin");
                            getApi(apiConfig.getBirthdayCheck, jwtInfo.token)
                                .then((response) => {
                                    var birthApiGetRes = response.data;
                                    if (birthApiGetRes.code === 200) {
                                        bannerLogin = JSON.parse(sessionStorage.getItem("bannerLogin"));
                                        sessionStorage.removeItem("bannerLogin");
                                        console.log(bannerLogin)
                                        if(birthApiGetRes.data === "Y" && !bannerLogin){
                                            router.push('/detail');
                                        }else if(birthApiGetRes.data === "Y" && bannerLogin){
                                            router.push('/');
                                        } else{
                                            router.push('/birthday');
                                        }
                                    } else {
                                        Swal.fire({
                                            title: "資料錯誤",
                                            confirmButtonText: "確定",
                                            showCloseButton: true,
                                            html: '<img src="error.svg"><p>'+ birthApiGetRes.message + '</p>',
                                        });
                                    }
                                    isLoading.value = false;
                                })
                                .catch(() => {
                                    Swal.fire({
                                        title: "資料錯誤",
                                        confirmButtonText: "確定",
                                        showCloseButton: true,
                                        html: '<img src="error.svg"><p>取得會員資料錯誤</p>',
                                    });
                                    isLoading.value = false;
                                });

                        }
                    }
                },
                (res)=>{
                    console.error(res)
                    Swal.fire({
                        title: "OTP 送出異常",
                        showCloseButton: true,
                        confirmButtonText: "確定",
                        html: '<img src="error.svg"><p>'+ res.message + '</p>',
                    });
                    isLoading.value = false
                },
                (res)=>{
                    console.error(res)
                    Swal.fire({
                        title: "系統異常",
                        showCloseButton: true,
                        confirmButtonText: "確定",
                        html: '<img src="error.svg"><p>確認OTP連線錯誤</p>',
                    });
                    isLoading.value = false
                }
            )

        }

        //OTP註冊
        const sendOTPRegister = ()=>{
            let regObj = JSON.parse(sessionStorage.getItem('regData'));
            let otpData = {
                otpId: otpInfo.value.otpId,
                otpFrontCode: otpInfo.value.otpFrontCode,
                otpBackCode: otpBackCode.value,
                name: regObj.name,
                mobile: regObj.mob,
                email: regObj.email,
                birthday: regObj.birthday.year +'-'+ regObj.birthday.month +'-'+ regObj.birthday.date,
                isMarketing: regData.isMarketing? 'Y' : null,//因此確認按鈕沒有明確表示為不同意則傳null
                source: 'https://www.tmnewa.com.tw/ec/travel/taiwan',
                terms: termsMemberList,
                sourceRemark: sourceRemark
            };

            userStatus.checkOtpRegister(
                otpData,
                (jwtInfo)=>{
                    isLoading.value = false;
                    localStorage.setItem('jwtInfo', JSON.stringify(jwtInfo));
                    sessionStorage.removeItem('otp');
                    sessionStorage.removeItem('otpType');
                    sessionStorage.removeItem('regData');
                    emits('checkLogin');
                    sendFpc();
                    gtm.memberEvent('sign_up');
                    sessionStorage.setItem("termsCheck", false);//紀錄使用者從註冊頁進來(移除下拉條款至detail)
                    bannerLogin = JSON.parse(sessionStorage.getItem("bannerLogin"));
                    sessionStorage.removeItem("bannerLogin");
                    if(bannerLogin){
                        router.push('/');
                    }else {
                        router.push('/detail');
                    }
                },
                (res) => {
                    Swal.fire({
                        title: "OTP 送出異常",
                        showCloseButton: true,
                        confirmButtonText: "確定",
                        html: '<img src="error.svg"><p>'+ res.message + '</p>',
                    });
                    isLoading.value = false
                },
                (res) => {
                    console.error(res)
                    Swal.fire({
                        title: "系統異常",
                        showCloseButton: true,
                        confirmButtonText: "確定",
                        html: '<img src="error.svg"><p>確認OTP連線錯誤</p>',
                    });
                    isLoading.value = false
                }
            );
        }

        //OTP付款
        const payOtpCheck = ()=>{
            const data = {
                'applicationNo': applicationNo,
                'otpFrontCode': otpInfo.value.otpFrontCode,
                'otpBackCode': otpBackCode.value,
            };
            const jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            postApi(apiConfig.payOtpCheck, jwtInfo.token, null, null, data)
                .then((response) => {
                    const payOtpCheckRes = response.data;
                    if (payOtpCheckRes.code === 200) {
                        isLoading.value = false;
                        sessionStorage.removeItem('otp');
                        sessionStorage.removeItem('otpType');
                        router.push("/pay");
                    } else {
                        isLoading.value = false;
                        Swal.fire({
                            title: "確認OTP錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            confirmButtonText: "確定",
                            html: '<img src="error.svg"><p>'+ payOtpCheckRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    isLoading.value = false;
                    Swal.fire({
                        title: "確認OTP錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        confirmButtonText: "確定",
                        html: '<img src="error.svg"><p>確認OTP連線錯誤</p>',
                    });
                });
        }

        const tidyTerms = () =>{
            let allterms = termsMember.concat(termsMemberTravel)
            termsMemberList = allterms.map((terms) =>{
                return {
                    id:terms.Id,
                    insures:terms.InsCategory,
                    cid:terms.NoteType,
                    publishDate: moment(terms.Date).format("YYYY-MM-DDTHH:mm:ss")
                }
            })
        }

        //重設OTP
        const resetOTP = () =>{
            switch (otpType) {
                case 'login':
                    otpLogin();
                    break;
                case 'register':
                    otpRegister();
                    break;
                case 'confirm':
                    sendPayOtp();
                    break;
            }
        }

        //登入OTP
        const otpLogin = () =>{
            if(!isOverflow){
                const loginData = {
                    account:logData.acc,
                    birthday:logData.birthday.year +'-'+ logData.birthday.month +'-'+ logData.birthday.date,
                    sourceRemark: sourceRemark
                }
                isLoading.value=true
                userStatus.otpLogin(
                    loginData,
                    (type, res)=>{
                        res.data.type = type
                        isLoading.value = false;
                        sessionStorage.setItem('otp', JSON.stringify(res.data));
                        otpObj = JSON.parse(sessionStorage.getItem("otp"));
                        counting.value = true;
                        resetCount();
                    },
                    (res) => {
                        Swal.fire({
                            title: res.message,
                            showConfirmButton: true,
                            showCloseButton: true,
                            confirmButtonText: '確定',
                            html: '<img src="error.svg">' +
                                '<p>親愛的客戶您好，您先前投保所使用之手機號碼和電子信箱，經查證屬實係為他人所有擁有。因未能與您取得聯繫，為避免造成原用戶困擾，已將您的手機號碼和電子信箱進行刪除。 </p>'+
                                '<p>為維護您的會員權益，<span class="red">請在看到此訊息後，盡速與客服人員聯繫更新您的聯絡資訊</span>，感謝您的配合。</p>'+
                                '<p>網路服務專線：0800-366-168 (服務時間：週一至週五上午8:30-下午5:30，國定假日除外)</p>',
                        }).then(function () {
                            router.push("/login");
                        });
                        isLoading.value = false
                    },
                    (res)=>{
                        Swal.fire({
                            title: "填寫資料錯誤",
                            confirmButtonText: '確定',
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>' + res.message + '</p>',
                        }).then(function () {
                            router.push("/login");
                        });
                        isLoading.value = false
                    },
                    (error)=>{
                        console.error(error)
                        Swal.fire({
                            title: "錯誤",
                            showCloseButton: true,
                            confirmButtonText: '確定',
                            html: '<img src="error.svg"><p>登入連線錯誤</p>',
                        }).then(function () {
                            router.push("/login");
                        });
                        isLoading.value = false
                    }
                );
            }else{
                Swal.fire({
                    title: "錯誤",
                    showCloseButton: true,
                    confirmButtonText: '確定',
                    html: '<img src="error.svg"><p>投保人數過多請稍後再試</p>',
                }).then(function () {
                    router.push("/login");
                });
                isLoading.value = false
            }
        }

        //登入OTP
        const otpRegister = () =>{
            isLoading.value=true
            if(!isOverflow){
                userStatus.otpRegister({
                        account: regData.acc,
                        name: regData.name,
                        mobile: regData.mob,
                        email: regData.email,
                        birthday:regData.birthday.year +'-'+ regData.birthday.month +'-'+ regData.birthday.date,
                        sourceRemark: sourceRemark
                    },
                    (type, res)=>{
                        isLoading.value = false;
                        res.data.type = type;
                        sessionStorage.setItem('otp', JSON.stringify(res.data));
                        otpObj = JSON.parse(sessionStorage.getItem("otp"));
                        counting.value = true;
                        resetCount();
                    },
                    (res)=>{
                        Swal.fire({
                            title: "填寫資料錯誤",
                            showCloseButton: true,
                            confirmButtonText: '確定',
                            html: '<img src="error.svg"><p>'+ res.message + '</p>',
                        }).then(function () {
                            router.push("/register");
                        });
                        isLoading.value = false
                    },
                    ()=>{
                        Swal.fire({
                            title: "錯誤",
                            showConfirmButton: true,
                            showCloseButton: true,
                            confirmButtonText: '確定',
                            html: '<img src="error.svg"><p>註冊連線錯誤</p>',
                        }).then(function () {
                            router.push("/register");
                        });
                        isLoading.value = false
                    }
                )
            }else{
                Swal.fire({
                    title: "錯誤",
                    confirmButtonText: "確定",
                    showCloseButton: true,
                    html: '<img src="error.svg"><p>投保人數過多請稍後再試</p>',
                });
                isLoading.value = false
            }
        }

        //登入OTP
        const sendPayOtp = () =>{
            var data = {
                'applicationNo': applicationNo,
            };
            const jwtInfo = JSON.parse(localStorage.getItem("jwtInfo"));
            postApi(apiConfig.payOtpSend, jwtInfo.token, null, null, data)
                .then((response) => {
                    var payOtpSendRes = response.data;
                    if (payOtpSendRes.code === 200) {
                        isLoading.value = false;
                        sessionStorage.setItem('otp', JSON.stringify(payOtpSendRes.data));
                        otpObj = JSON.parse(sessionStorage.getItem("otp"));
                        counting.value = true;
                        resetCount();
                    } else {
                        Swal.fire({
                            title: "發送OTP錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            confirmButtonText: "確定",
                            html: '<img src="error.svg"><p>'+ payOtpSendRes.message + '</p>',
                        });
                    }
                })
                .catch((error) => {
                    console.log(error)
                    Swal.fire({
                        title: "發送OTP錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        confirmButtonText: "確定",
                        html: '<img src="error.svg"><p>發送OTP連線錯誤</p>',
                    });
                });
        }

        //確認系統超載
        const overflowCheck = ()=>{
            userStatus.isOverflow((res)=>{
                if(res.code !== 200){
                    isOverflow = true;
                }
            })
        }

        const otpAlert = () =>{
            switch (otpType) {
                case 'login':
                    Swal.fire({
                        title: "若您一直沒有收到驗證碼",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="noticemark.svg">' +
                            '<ul><li>請確認您的手機號碼或電子郵件是否填寫正確。</li>'+
                            '<li>是否有拒收企業簡訊的設定(建議可洽詢您的電信業者更改設定)。</li>'+
                            '<li>請確認目前所在位置收訊良好。</li>'+
                            '<li>有可能被誤判定為垃圾簡訊及垃圾郵件，請至垃圾訊息區確認。</li>' +
                            '<li>若您的手機號碼或電子郵件已變更，請聯繫客服，修改您的個人資料。客服專線：0800-366-168</li>' +
                            '</ul>',
                        customClass: {
                            container: "otpAlert",
                        },
                    });
                    break;
                case 'register':
                    Swal.fire({
                        title: "若您一直沒有收到驗證碼",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="noticemark.svg">' +
                            '<ul><li>請確認您的手機號碼或電子郵件是否填寫正確。</li>'+
                            '<li>是否有拒收企業簡訊的設定(建議可洽詢您的電信業者更改設定)。</li>'+
                            '<li>請確認目前所在位置收訊良好。</li>'+
                            '<li>有可能被誤判定為垃圾簡訊及垃圾郵件，請至垃圾訊息區確認。</li>' +
                            '</ul>',
                        customClass: {
                            container: "otpAlert",
                        },
                    }).then(function () {
                        router.push('/register')
                    });
                    break;
                case 'confirm':
                    Swal.fire({
                        title: "若您一直沒有收到驗證碼",
                        confirmButtonText: "確定",
                        showCloseButton: true,
                        html: '<img src="noticemark.svg">' +
                            '<ul><li>請確認您的手機號碼或電子郵件是否填寫正確。</li>'+
                            '<li>是否有拒收企業簡訊的設定(建議可洽詢您的電信業者更改設定)。</li>'+
                            '<li>請確認目前所在位置收訊良好。</li>'+
                            '<li>有可能被誤判定為垃圾簡訊及垃圾郵件，請至垃圾訊息區確認。</li>' +
                            '<li>若您的手機號碼或電子郵件已變更，請聯繫客服，修改您的個人資料。客服專線：0800-366-168</li>' +
                            '</ul>',
                        customClass: {
                            container: "otpAlert",
                        },
                    });
                    break;
            }

        }

        //載入頁面資料(載入順序問題需要一開始 setup就載入)
        getData();
        const sendFpc = ()=>{
            const fpcInfo = JSON.parse(sessionStorage.getItem('fpcInfo'));
            if(fpcInfo){
                const data = {
                    pid:otpInfo.value.otpId,
                    fpc:fpcInfo.fpc,
                    clarityId: fpcInfo.clarityId,
                    sessionId: fpcInfo.sessionId
                }

                userStatus.sendFpc(data,null,null);
            }
        }

        onMounted(()=>{
            popUp();//公告系統
            overflowCheck();
            gtm.pageViewEvent();
            if(sessionStorage.getItem('termsMember') !== null){
                termsMember = JSON.parse(sessionStorage.getItem("termsMember"));
                termsMemberTravel = JSON.parse(sessionStorage.getItem("termsMemberTravel"));
                tidyTerms();
            }
        })

</script>

<style lang="scss">
#OTP {
    text-align: center;
    box-sizing: border-box;
    color: $textColor;

    .icon {
        display: inline-block;
        margin: 30px auto;
    }

    h2 {
        font-weight:500;
        color: $blue-700;
    }

    .code {
        display: flex;
        width: 500px;
        margin: 20px auto;

        @media screen and (max-width: $small) {
            width: 95%;
        }

        span {
            font-size: 26px;
            line-height: 25px;

            &.frontCode {
                font-size: 16px;
                margin: 0 5px;
            }
        }

        .inputStyle {
            height: 35px;
            line-height: 35px;
            box-sizing: border-box;
            position: relative;
            top: -5px;
            margin-left: 5px;
            text-align: center;
            width: calc(100% - 50px);
        }
    }

    .countDown {
        margin: 20px 0 30px;
    }
    .btnArea{margin:0 0 40px;}

    .otpBottom{
        text-align:center;
        margin-bottom:80px;
        .container{
            font-size:16px;
            line-height:25px;
            .attention{width:16px;margin-right:5px;position: relative;top:2px;}
            @media screen and (max-width: $small){
                width:100%;
            }
        }
    }
    .vue-countdown {
        display: inline-block
    }
    .btn.send{
        background:$yellow;
        color:$textColor;
    }
}
.otpAlert .swal2-html-container{
    p{text-align:left;}
    ul{list-style-type: decimal;text-align:left;padding:0 20px;}
}

</style>
